import React from 'react'
import { Icon, Themed } from '../'
import styles from './Button.module.css'

const Button = props => {
  const IconComponent = props.iconComponent || Icon

  return (
    <Themed styles={styles} theme={props.theme}>
      {(cx, css) => (
        <div
          className={cx({
            base: true,
            isLoading: props.loading,
            isLarge: props.large,
            isSimple: props.simple,
            isDisabled: props.disabled,
            isOutlined: props.outline,
            isInversed: props.inversed,
            hasFullWidth: props.full,
            [`has-icon-pos-${props.iconPos}`]: props.icon && props.iconPos,
            ...props.classNames,
            'button-el': true,
          })}
          onClick={props.onClick}
          onMouseOver={props.onMouseOver}
          onMouseOut={props.onMouseOut}
          style={props.style}>
          <div>
            {props.label &&
              <div className={`${css.label} button-label-el`}>
                {props.label}
              </div>
            }

            {props.icon &&
              <div className={`${css.icon} button-icon-el`}>
                {props.info &&
                  <div className={`${css.info} button-info-el`}>
                    {props.info}
                  </div>
                }
                <IconComponent name={props.icon} size={props.iconSize} />
              </div>
            }
          </div>
        </div>
      )}
    </Themed>
  )
}

const ButtonsGroup = props => {
  return (
    <Themed styles={styles} theme={props.theme}>
      {(cx, css) => (
        <div className={cx({
          group: true,
          isAuto: props.auto,
          isFull: props.full,
          isRight: props.right,
          isCenter: props.center,
          isVertical: props.vertical,
        })}>
          {props.children}
        </div>
      )}
    </Themed>
  )
}

Button.defaultProps = {
  label: null,
  icon: null,
  iconPos: 'left',
  iconSize: 'small',
}

Button.ButtonsGroup = {
  right: null,
  center: true,
}

export default Button
export { ButtonsGroup }
